import { render } from "./dashboards.vue?vue&type=template&id=73d36024&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=js"
export * from "./dashboards.vue?vue&type=script&lang=js"

import "./dashboards.vue?vue&type=style&index=0&id=73d36024&lang=scss"
import "./dashboards.vue?vue&type=style&index=1&id=73d36024&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d36024"]])

export default __exports__